import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base } from "../base";
import { IEnumApi } from "../enum-api";

export const ExtraInfomation = types
  .compose(
    Base,
    types.model({
      employmentStartDate: types.maybeNull(types.string),
      birthDate: types.maybeNull(types.string),
      nationalIDNumber: types.maybeNull(types.string),
      nationalIDIssueDate: types.maybeNull(types.string),
      nationalIDAddress: types.maybeNull(types.string),
      registeredHometown: types.maybeNull(types.string),
      birthCertificatePlace: types.maybeNull(types.string),
      phoneNumber: types.maybeNull(types.string),
      email: types.maybeNull(types.string),
      bankAccountNumber: types.maybeNull(types.string),
      contact: types.maybeNull(types.string),
      recruitmentSourceType: types.maybeNull(types.number),
      internalRelationship: types.maybeNull(types.string),
      status: types.maybeNull(types.number),
      leavingDate: types.maybeNull(types.string),
      leavingReason: types.maybeNull(types.string),
      note: types.maybeNull(types.string),
      recruitmentSourceTypeModel: types.maybeNull(types.frozen<IEnumApi>()),
      statusModel: types.maybeNull(types.frozen<IEnumApi>()),
    })
  )

  .actions(withSetPropAction);
export interface IExtraInfomation extends Instance<typeof ExtraInfomation> {}
export interface IExtraInfomationProperties
  extends SnapshotIn<typeof ExtraInfomation> {}

export interface IUpdateExtraInfomation
  extends Pick<
    IExtraInfomationProperties,
    | "employmentStartDate"
    | "birthDate"
    | "nationalIDNumber"
    | "nationalIDIssueDate"
    | "nationalIDAddress"
    | "registeredHometown"
    | "birthCertificatePlace"
    | "phoneNumber"
    | "email"
    | "bankAccountNumber"
    | "contact"
    | "recruitmentSourceType"
    | "internalRelationship"
    | "status"
    | "leavingDate"
    | "leavingReason"
    | "note"
  > {}
